// libs
import { styled } from '@nykaa/ui-components';
import { truncate } from 'shared/styles/mixin';
import { DWEB_ICON_BREAKPOINT } from 'shared/styles/base';

export const CartContainer = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 24px;
  flex-shrink: 1;
`;

export const Icon = styled.i`
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  font-size: 20px;
`;

export const TextContainer = styled.div`
  width: 100%;
  ${truncate}
  @media screen and (max-width: ${DWEB_ICON_BREAKPOINT}) {
    display: none;
  }
`;

export const CartCount = styled.div`
  position: absolute;
  background: #fd7685;
  color: #fff;
  font-weight: 500;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.bodyMedium}
  left: 8px;
  top: 0px;
`;
